import React from 'react'
import { HorizontalStack, Link } from '@ztechapps/webui.util'
import { Collapse, Dropdown } from 'react-bootstrap'
import { ClearFilter } from './ClearFilter'
import { useToggle } from 'react-use'

export const FilterGroup = ({
  children,
  title,
  filterName,
}: {
  children: React.ReactNode
  title: string
  filterName: string
}) => {
  const [show, setShow] = useToggle(true)

  return (
    <div className="border-bottom py-3 my-1">
      <div>
        <HorizontalStack className="justify-content-between">
          <Dropdown.Toggle as={Link} onClick={setShow}>
            {title}
          </Dropdown.Toggle>
          <ClearFilter filterName={filterName} />
        </HorizontalStack>
      </div>

      <Collapse in={show}>
        <div className="py-2">{children}</div>
      </Collapse>
    </div>
  )
}
